var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 32,
    cy: 32,
    r: 32,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.25 32C42.25 32.6562 41.7344 33.125 41.125 33.125H33.625V40.625C33.625 41.2812 33.1094 41.7969 32.5 41.7969C31.8438 41.7969 31.375 41.2812 31.375 40.625V33.125H23.875C23.2188 33.125 22.75 32.6562 22.75 32.0469C22.75 31.3906 23.2188 30.875 23.875 30.875H31.375V23.375C31.375 22.7656 31.8438 22.2969 32.5 22.2969C33.1094 22.2969 33.625 22.7656 33.625 23.375V30.875H41.125C41.7344 30.875 42.25 31.3906 42.25 32Z",
    fill: "#25272C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusMobileIcon);
export default __webpack_public_path__ + "static/media/plusMobileIcon.6a3323b700159258460651248d43d995.svg";
export { ForwardRef as ReactComponent };